export interface AgentFormValues {
	name: string;
	categoryId: string | null;
	title: string;
	description: string;
	// The two prompt bodies, authored on the create modal alongside the metadata. Optional at
	// create time — an agent is catalogued from name/category/title/description, and the prompts are
	// what make it functional (required to test/deploy it), so they can be filled in here or later
	// on the Prompt tab. They are persisted right after create via a follow-up save (see the create
	// handler in NovaStudioShell).
	systemPrompt: string;
	userPromptTemplate: string;
}

export const DEFAULT_AGENT_FORM: AgentFormValues = {
	name: '',
	categoryId: null,
	title: '',
	description: '',
	systemPrompt: '',
	userPromptTemplate: '',
};

export function validateAgentForm(
	values: AgentFormValues,
	existingNames: string[]
): {isValid: boolean; missing: Array<keyof AgentFormValues>; duplicateName: boolean} {
	const missing: Array<keyof AgentFormValues> = [];
	if (!values.name.trim()) {
		missing.push('name');
	}
	if (!values.categoryId) {
		missing.push('categoryId');
	}
	if (!values.title.trim()) {
		missing.push('title');
	}
	if (!values.description.trim()) {
		missing.push('description');
	}
	const duplicateName = values.name.trim().length > 0 && existingNames.includes(values.name.trim());
	return {isValid: missing.length === 0, missing, duplicateName};
}
